import { c as _c } from "react/compiler-runtime";
import useSWR from "swr";

// Subscribe to the current query immediately, but debounce network requests.
// A null request key must not hide an already cached response while typing.
export function useCachedSearchResults(key, fetcher, t0) {
  const $ = _c(6);
  const ready = t0 === undefined ? true : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      dedupingInterval: 60000
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const options = t1;
  const cached = useSWR(key, null, options);
  const request = useSWR(ready ? key : null, fetcher, options);
  const t2 = Boolean(key && !cached.data && !cached.error);
  let t3;
  if ($[1] !== cached || $[2] !== request.isValidating || $[3] !== request.mutate || $[4] !== t2) {
    t3 = {
      ...cached,
      isLoading: t2,
      isValidating: request.isValidating,
      mutate: request.mutate
    };
    $[1] = cached;
    $[2] = request.isValidating;
    $[3] = request.mutate;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}